import { createContext } from 'react';

const useAllocationContext = createContext();
export default useAllocationContext;
